import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { clearHistory } from "../slices/historySlice";
import { useFlags } from "launchdarkly-react-client-sdk";
import PropTypes from "prop-types";

function Redirect(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { displayReports } = useFlags();

    const loggedInUser = useSelector((state) => state.auth.user);
    const { totalParentOrganizations, selectedOrganizations } = useSelector(
        (state) => state.organizations
    );

    const stateHistory = useSelector((state) => state.history);
    const homePreference = useSelector(
        (state) => state.preferenceSlice.homePreference
    );

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (!loggedInUser) {
            const params = Object.fromEntries(searchParams.entries());
            navigate(
                { pathname: "/login" },
                {
                    state: {
                        params,
                    },
                }
            );
            return;
        }

        if (Object.keys(stateHistory).length > 0) {
            dispatch(clearHistory());
        }

        if (
            totalParentOrganizations === 1 &&
            Object.keys(selectedOrganizations).length > 0
        ) {
            const organization = Object.values(selectedOrganizations)[0]
                .organization;

            navigate(
                !displayReports ||
                    props.previousUrl.includes("/home") ||
                    homePreference?.toString() === "search"
                    ? `/organization/${organization.ORGANIZATIONID}/employees/search`
                    : `/home`
            );
        } else {
            navigate(displayReports ? "/home" : "/search");
        }
    }, [
        loggedInUser,
        totalParentOrganizations,
        selectedOrganizations,
        displayReports,
        homePreference,
        stateHistory,
        dispatch,
        navigate,
        searchParams
    ]);

    return null;
}

Redirect.propTypes = {
    previousUrl: PropTypes.array,
};

export default Redirect;
